import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, vShow as _vShow, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox } from "vue"
import _imports_0 from '@/assets/images/logo_white.png'
import _imports_1 from '@/assets/images/4.png'
import _imports_2 from '@/assets/images/7.png'
import _imports_3 from '@/assets/images/101.png'
import _imports_4 from '@/assets/images/2.png'
import _imports_5 from '@/assets/images/9.png'
import _imports_6 from '@/assets/images/10.png'


const _hoisted_1 = { class: "login-page" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "language-selector" }
const _hoisted_4 = { class: "main-content" }
const _hoisted_5 = { class: "login-section" }
const _hoisted_6 = { class: "login-card" }
const _hoisted_7 = { class: "welcome-text" }
const _hoisted_8 = { class: "login-tabs" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = ["type", "placeholder"]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "form-options" }
const _hoisted_18 = {
  class: "checkbox-label",
  style: {"opacity":"0"}
}
const _hoisted_19 = {
  key: 1,
  class: "login-form"
}
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = ["placeholder"]
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = ["placeholder"]
const _hoisted_24 = ["disabled"]
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "form-options" }
const _hoisted_28 = {
  class: "checkbox-label",
  style: {"opacity":"0"}
}
const _hoisted_29 = {
  key: 2,
  class: "login-form"
}
const _hoisted_30 = { class: "form-group" }
const _hoisted_31 = ["placeholder"]
const _hoisted_32 = { class: "form-group" }
const _hoisted_33 = ["placeholder"]
const _hoisted_34 = ["disabled"]
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { class: "form-options" }
const _hoisted_38 = {
  class: "checkbox-label",
  style: {"opacity":"0"}
}
const _hoisted_39 = { class: "register-section" }

import { ref, reactive, computed, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import SelectLanguage from '@/components/SelectLanguage.vue';
import { useUtils } from '@/common/utils/useUtils';
import { post } from '@/common/utils/useRequest';
import { useAreaCode } from '@/common/utils/useAreaCode';
import { useUserStore } from '@/store/user';
import { TryError } from '@/types/global';
import { useCode } from '@/common/utils/useCode';
import { useI18n } from 'vue-i18n';
interface LoginTab {
	id: 'password' | 'phone' | 'email';
	label: string;
}

interface PasswordLoginForm {
	account: string;
	password: string;
	autoLogin: boolean;
}

interface PhoneLoginForm {
	phone: string;
	verificationCode: string;
	autoLogin: boolean;
}

interface EmailLoginForm {
	email: string;
	verificationCode: string;
	autoLogin: boolean;
}

interface FormErrors {
	[key: string]: string;
}

// 响应式数据

export default /*@__PURE__*/_defineComponent({
  __name: 'login',
  setup(__props) {

const router = useRouter();
const { err_msg, suc_msg } = useUtils();
const { codeObject } = useAreaCode();
const userStore = useUserStore();

const { t } = useI18n();
console.debug('t', t('年龄'));

// 类型定义
const activeTab = ref<'password' | 'phone' | 'email'>('password');
const showPassword = ref(false);
const isLoggingIn = ref(false);
const isCountingDown = ref(false);
const countdown = ref(60);

const code_object = ref(useCode(t));
code_object.value.codeType = 3;

const email_code_object = ref(useCode(t));
email_code_object.value.codeType = 3;

onUnmounted(() => {
	code_object.value.closeFn();
	email_code_object.value.closeFn();
});

// 登录方式标签
const loginTabs: LoginTab[] = reactive([
	{ id: 'password', label: '密码登录' },
	{ id: 'phone', label: '手机号验证' },
	{ id: 'email', label: '邮箱验证' }
]);

// 表单数据
const passwordLoginForm = reactive<PasswordLoginForm>({
	account: '',
	password: '',
	autoLogin: false
});

const phoneLoginForm = reactive<PhoneLoginForm>({
	phone: '',
	verificationCode: '',
	autoLogin: false
});

const emailLoginForm = reactive<EmailLoginForm>({
	email: '',
	verificationCode: '',
	autoLogin: false
});

// 表单错误信息
const passwordLoginErrors = reactive<FormErrors>({});
const phoneLoginErrors = reactive<FormErrors>({});
const emailLoginErrors = reactive<FormErrors>({});

// 切换登录方式
const switchTab = (tabId: 'password' | 'phone' | 'email') => {
	activeTab.value = tabId;
	// 清除表单错误
	clearFormErrors();
};

// 清除表单错误
const clearFormErrors = () => {
	Object.keys(passwordLoginErrors).forEach((key) => {
		passwordLoginErrors[key] = '';
	});
	Object.keys(phoneLoginErrors).forEach((key) => {
		phoneLoginErrors[key] = '';
	});
	Object.keys(emailLoginErrors).forEach((key) => {
		emailLoginErrors[key] = '';
	});
};

// 验证手机号格式
const validatePhone = (phone: string): boolean => {
	const phoneRegex = /^1[3-9]\d{9}$/;
	return phoneRegex.test(phone);
};

// 验证邮箱格式
const validateEmail = (email: string): boolean => {
	const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	return emailRegex.test(email);
};

// 验证密码格式
const validatePwd = (pwd: string): boolean => {
	const emailRegex = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9a-zA-Z]{6,12}$/;
	return emailRegex.test(pwd);
};

// 密码登录处理
const handlePasswordLogin = async () => {
	// 清除之前的错误
	clearFormErrors();

	// 简单验证
	let hasError = false;

	// console.debug('form', passwordLoginForm);

	if (!passwordLoginForm.account.trim()) {
		err_msg(t('请输入手机号或邮箱'));
		hasError = true;
	} else if (
		!validatePhone(passwordLoginForm.account.trim()) &&
		!validateEmail(passwordLoginForm.account.trim())
	) {
		err_msg(t('请正确输入手机号或邮箱'));
		hasError = true;
	} else if (!passwordLoginForm.password.trim()) {
		err_msg(t('请输入密码(6~12位字母+数字)'));
		hasError = true;
	} else if (!validatePwd(passwordLoginForm.password)) {
		err_msg(t('请输入正确的密码(6~12位字母+数字)'));
		hasError = true;
	}

	if (hasError) {
		return;
	}

	// 模拟登录请求
	isLoggingIn.value = true;
	try {
		// 这里可以替换为实际的API调用
		const res = await post('5c78dbfd977cf', {
			account: passwordLoginForm.account.trim(),
			account_type: validatePhone(passwordLoginForm.account.trim()) ? 1 : 2,
			password: passwordLoginForm.password.trim(),
			area_code: codeObject.phoneCode
		});
		suc_msg(t('登录成功！'));
		userStore.saveToken(res.data.userinfo.user_token);
		userStore.saveUserInfo(res.data.userinfo);
		userStore.getUserInfo();
		router.push('/home/gailan');
	} catch (error: any) {
		console.error('登录失败1:', error);
		err_msg(error.msg || t('登录失败'));
	} finally {
		isLoggingIn.value = false;
	}
};

// 手机号登录处理
const handlePhoneLogin = async () => {
	clearFormErrors();
	let hasError = false;

	if (!phoneLoginForm.phone.trim()) {
		err_msg(t('请输入手机号'));
		hasError = true;
	} else if (!validatePhone(phoneLoginForm.phone)) {
		err_msg(t('手机号格式不正确'));
		hasError = true;
	} else if (!phoneLoginForm.verificationCode.trim()) {
		err_msg(t('请输入验证码'));
		hasError = true;
	} /*  else if (phoneLoginForm.verificationCode.length !== 6) {
		phoneLoginErrors.verificationCode = '验证码为6位数字';
		hasError = true;
	} */

	if (hasError) return;

	isLoggingIn.value = true;
	try {
		const res = await post('5c78dca45ebc1', {
			account: phoneLoginForm.phone.trim(),
			account_type: 1,
			code: phoneLoginForm.verificationCode.trim(),
			type: '3',
			area_code: codeObject.phoneCode
		});
		suc_msg(t('登录成功！'));
		userStore.saveToken(res.data.userinfo.user_token);
		userStore.saveUserInfo(res.data.userinfo);
		userStore.getUserInfo();
		router.push('/home/gailan');
	} catch (error: any) {
		console.error('登录失败1:', error);
		err_msg(error.msg || t('登录失败'));
	} finally {
		isLoggingIn.value = false;
	}
};

// 邮箱登录处理
const handleEmailLogin = async () => {
	clearFormErrors();
	let hasError = false;

	if (!emailLoginForm.email.trim()) {
		err_msg(t('请输入邮箱'));
		hasError = true;
	} else if (!validateEmail(emailLoginForm.email)) {
		err_msg(t('邮箱格式不正确'));
		hasError = true;
	} else if (!emailLoginForm.verificationCode.trim()) {
		err_msg(t('请输入验证码'));
		hasError = true;
	} /*  else if (emailLoginForm.verificationCode.length !== 6) {
		emailLoginErrors.verificationCode = '验证码为6位数字';
		hasError = true;
	} */

	if (hasError) return;

	isLoggingIn.value = true;
	try {
		const res = await post('5c78dca45ebc1', {
			account: emailLoginForm.email.trim(),
			account_type: 2,
			code: emailLoginForm.verificationCode.trim(),
			type: '3',
			area_code: codeObject.phoneCode
		});
		suc_msg(t('登录成功！'));
		userStore.saveToken(res.data.userinfo.user_token);
		userStore.saveUserInfo(res.data.userinfo);
		userStore.getUserInfo();
		router.push('/home/gailan');
	} catch (error: any) {
		console.error('登录失败1:', error);
		err_msg(error.msg || t('登录失败'));
	} finally {
		isLoggingIn.value = false;
	}
};

// 忘记密码处理
const handleForgotPassword = () => {
	router.push('/wangjiPwd');
};

// 注册处理
const handleRegister = () => {
	router.push('/register');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[16] || (_cache[16] = _createElementVNode("img", {
        src: _imports_0,
        alt: "",
        class: "logoIcon"
      }, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(SelectLanguage)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[23] || (_cache[23] = _createElementVNode("div", { class: "server-section" }, null, -1)),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("h1", _hoisted_7, _toDisplayString(_ctx.$t("欢迎使用交换机云平台")), 1),
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(loginTabs, (tab) => {
              return (_openBlock(), _createElementBlock("button", {
                key: tab.id,
                class: _normalizeClass(['tab-button', { active: activeTab.value === tab.id }]),
                onClick: ($event: any) => (switchTab(tab.id))
              }, _toDisplayString(_ctx.$t(tab.label)), 11, _hoisted_9))
            }), 128))
          ]),
          (activeTab.value === 'password')
            ? (_openBlock(), _createElementBlock("form", {
                key: 0,
                onSubmit: _withModifiers(handlePasswordLogin, ["prevent"]),
                class: "login-form"
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "account",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((passwordLoginForm.account) = $event)),
                    placeholder: _ctx.$t('请输入手机号或邮箱')
                  }, null, 8, _hoisted_11), [
                    [_vModelText, passwordLoginForm.account]
                  ]),
                  _cache[17] || (_cache[17] = _createElementVNode("img", {
                    src: _imports_1,
                    alt: "",
                    class: "icon1"
                  }, null, -1))
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _withDirectives(_createElementVNode("input", {
                    type: showPassword.value ? 'text' : 'password',
                    id: "password",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((passwordLoginForm.password) = $event)),
                    placeholder: _ctx.$t('请输入密码(6~12位字母+数字)')
                  }, null, 8, _hoisted_13), [
                    [_vModelDynamic, passwordLoginForm.password]
                  ]),
                  _cache[18] || (_cache[18] = _createElementVNode("img", {
                    src: _imports_2,
                    alt: "",
                    class: "icon1"
                  }, null, -1)),
                  _withDirectives(_createElementVNode("img", {
                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (showPassword.value=!showPassword.value), ["stop"])),
                    src: _imports_3,
                    alt: "",
                    class: "icon2"
                  }, null, 512), [
                    [_vShow, showPassword.value]
                  ]),
                  _withDirectives(_createElementVNode("img", {
                    onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (showPassword.value=!showPassword.value), ["stop"])),
                    src: _imports_4,
                    alt: "",
                    class: "icon2"
                  }, null, 512), [
                    [_vShow, !showPassword.value]
                  ])
                ]),
                _createElementVNode("button", {
                  type: "submit",
                  class: "login-button",
                  disabled: isLoggingIn.value
                }, [
                  (!isLoggingIn.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.$t("登录")), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.$t("登录中")) + "...", 1))
                ], 8, _hoisted_14),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("label", _hoisted_18, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((passwordLoginForm.autoLogin) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, passwordLoginForm.autoLogin]
                    ]),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("自动登录")), 1)
                  ]),
                  _createElementVNode("a", {
                    href: "#",
                    class: "forgot-password",
                    onClick: _withModifiers(handleForgotPassword, ["prevent"])
                  }, _toDisplayString(_ctx.$t("忘记密码")), 1)
                ])
              ], 32))
            : (activeTab.value === 'phone')
              ? (_openBlock(), _createElementBlock("form", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _withDirectives(_createElementVNode("input", {
                      type: "tel",
                      id: "phone",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((phoneLoginForm.phone) = $event)),
                      placeholder: _ctx.$t('请输入手机号'),
                      pattern: "[0-9]{11}",
                      onInput: _cache[6] || (_cache[6] = ($event: any) => (phoneLoginForm.phone=String(phoneLoginForm.phone).slice(0,11)))
                    }, null, 40, _hoisted_21), [
                      [_vModelText, phoneLoginForm.phone]
                    ]),
                    _cache[19] || (_cache[19] = _createElementVNode("img", {
                      src: _imports_1,
                      alt: "",
                      class: "icon1"
                    }, null, -1))
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      id: "phoneCode",
                      style: {"padding-right":"40%"},
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((phoneLoginForm.verificationCode) = $event)),
                      placeholder: _ctx.$t('请输入验证码'),
                      onInput: _cache[8] || (_cache[8] = ($event: any) => (phoneLoginForm.verificationCode=String(phoneLoginForm.verificationCode).slice(0,6)))
                    }, null, 40, _hoisted_23), [
                      [_vModelText, phoneLoginForm.verificationCode]
                    ]),
                    _createElementVNode("span", {
                      class: _normalizeClass(["getCode pointer", {dis:code_object.value.isCodeStart}]),
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (code_object.value.getCodeApiHandleFn(phoneLoginForm.phone)))
                    }, _toDisplayString(code_object.value.isCodeStart? (code_object.value.codePlac || '') : _ctx.$t("获取验证码")), 3),
                    _cache[20] || (_cache[20] = _createElementVNode("img", {
                      src: _imports_5,
                      alt: "",
                      class: "icon1"
                    }, null, -1))
                  ]),
                  _createElementVNode("button", {
                    type: "submit",
                    class: "login-button",
                    disabled: isLoggingIn.value,
                    onClick: handlePhoneLogin
                  }, [
                    (!isLoggingIn.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.$t("登录")), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.$t("登录中")) + "...", 1))
                  ], 8, _hoisted_24),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("label", _hoisted_28, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((phoneLoginForm.autoLogin) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, phoneLoginForm.autoLogin]
                      ]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("自动登录")), 1)
                    ]),
                    _createElementVNode("a", {
                      href: "#",
                      class: "forgot-password",
                      onClick: _withModifiers(handleForgotPassword, ["prevent"])
                    }, _toDisplayString(_ctx.$t("忘记密码")), 1)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("form", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _withDirectives(_createElementVNode("input", {
                      type: "email",
                      id: "email",
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((emailLoginForm.email) = $event)),
                      placeholder: _ctx.$t('请输入邮箱')
                    }, null, 8, _hoisted_31), [
                      [_vModelText, emailLoginForm.email]
                    ]),
                    _cache[21] || (_cache[21] = _createElementVNode("img", {
                      src: _imports_6,
                      alt: "",
                      class: "icon1"
                    }, null, -1))
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      id: "emailCode",
                      style: {"padding-right":"40%"},
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((emailLoginForm.verificationCode) = $event)),
                      placeholder: _ctx.$t('请输入验证码'),
                      onInput: _cache[13] || (_cache[13] = ($event: any) => (emailLoginForm.verificationCode=String(emailLoginForm.verificationCode).slice(0,6)))
                    }, null, 40, _hoisted_33), [
                      [_vModelText, emailLoginForm.verificationCode]
                    ]),
                    _createElementVNode("span", {
                      class: _normalizeClass(["getCode pointer", {dis:email_code_object.value.isCodeStart}]),
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (email_code_object.value.getCodeApiHandleFn(emailLoginForm.email,'email')))
                    }, _toDisplayString(email_code_object.value.isCodeStart? (email_code_object.value.codePlac || '') : _ctx.$t("获取验证码")), 3),
                    _cache[22] || (_cache[22] = _createElementVNode("img", {
                      src: _imports_5,
                      alt: "",
                      class: "icon1"
                    }, null, -1))
                  ]),
                  _createElementVNode("button", {
                    type: "submit",
                    class: "login-button",
                    disabled: isLoggingIn.value,
                    onClick: handleEmailLogin
                  }, [
                    (!isLoggingIn.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(_ctx.$t('登录')), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(_ctx.$t('登录中')) + "...", 1))
                  ], 8, _hoisted_34),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("label", _hoisted_38, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((emailLoginForm.autoLogin) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, emailLoginForm.autoLogin]
                      ]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('自动登录')), 1)
                    ]),
                    _createElementVNode("a", {
                      href: "#",
                      class: "forgot-password",
                      onClick: _withModifiers(handleForgotPassword, ["prevent"])
                    }, _toDisplayString(_ctx.$t('忘记密码')), 1)
                  ])
                ])),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('没有账号，')), 1),
            _createElementVNode("a", {
              href: "#",
              class: "register-link",
              onClick: _withModifiers(handleRegister, ["prevent"])
            }, _toDisplayString(_ctx.$t("去注册")), 1)
          ])
        ])
      ])
    ])
  ]))
}
}

})